// WageLens Brand Colors - Dark Mode Optimized
export const COLORS = {
  navy: '#1B3A6B',
  teal: '#2EC4B6',
  lightBlue: '#5A7AAF',
  compliant: '#34D399',
  nonCompliant: '#F87171',
  overCompliant: '#FBBF24',
  notEvaluated: '#9CA3AF'
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
